"use client";
import React, { ReactNode } from "react";
import { Nft } from "@/api/nfts/types";
import EntityModalBase from "../EntityModalBase/EntityModalBase";
import { getUsersName } from "@/api/users/helpers";
import { ImageTypeHandler } from "@/app/(components)/Basic/ImageTypeHandler";
import {
  DEFAULT_SMALL_NFT_HEIGHT,
  DEFAULT_SMALL_NFT_WIDTH,
} from "@/shared/constants";
export interface Props {
  nft: Nft;
  title: string;
  children: ReactNode;
  isOpen: boolean;
  onClose: () => void;
  disableClose?: boolean;
  hasCloseButton?: boolean;
}

function NftModalBase({ nft, children, ...props }: Props) {
  return (
    <EntityModalBase {...props} grandChildren={children}>
      <ImageTypeHandler
        src={nft.thumbnail || nft.image}
        placeholder={nft.placeholder}
        type={nft.mediaType}
        width={nft.imageWidth || DEFAULT_SMALL_NFT_WIDTH}
        height={nft.imageHeight || DEFAULT_SMALL_NFT_HEIGHT}
        alt={nft.name}
        className={"max-h-[110px] w-auto mb-4"}
      />
      <div className="text-body-1 max-w-[400px] w-full break-words">
        {nft.name}
      </div>
      <h3 className="text-body-2 text-secondary mb-6 endemic:text-endemicGray-700">
        by {getUsersName(nft.artist, true)}
      </h3>
    </EntityModalBase>
  );
}

export default NftModalBase;
